import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";

const CalendarSelectFieldGroup = ({
  label,
  name,
  value,
  error,
  disabled,
  inputRef,
  formItemLayout,
  onChange,
  allowClear = true,
}) => (
  <Form.Item
    label={label}
    validateStatus={error ? "error" : ""}
    help={error}
    {...formItemLayout}
  >
    <DatePicker
      multiple
      plugins={[<DatePanel />]}
      disabled={disabled}
      onChange={onChange}
      value={value}
      ref={inputRef}
      calendarPosition="bottom-center"
      fixMainPosition={true}
    />
  </Form.Item>
);

CalendarSelectFieldGroup.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  inputRef: PropTypes.func,
  disabled: PropTypes.bool,
};

CalendarSelectFieldGroup.defaultProps = {
  disabled: false,
};

export default CalendarSelectFieldGroup;
